import React from 'react';

const LinkedIn = ({ width = 14, height = 14, fill = '#fff', ...rest }) => (
  <svg width={width} height={height} viewBox="0 0 14 14" {...rest}>
    <path
      d="M2.3 3.5c-.4 0-.8-.1-1.1-.4-.3-.3-.4-.6-.4-1s.1-.8.4-1.1c.3-.3.7-.4 1.1-.4.4 0 .8.1 1.1.4.3.3.4.7.4 1.1 0 .4-.1.8-.4 1-.3.3-.6.4-1.1.4zm1.3 10H.8V4.8h2.8v8.7zm7.1-8.9c.9 0 1.7.3 2.3 1 .6.6.9 1.6.9 2.8v5.1h-2.8V8.7c0-1.3-.5-1.9-1.4-1.9-.7 0-1.2.3-1.4 1-.1.1-.1.4-.1.7v4.9H5.4V4.7h2.8v1.2c.6-.8 1.4-1.3 2.5-1.3z"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
);

export default LinkedIn;
